import { Component } from "react";
import FormatCurrencyService from "../../services/FormatCurrencyService";
import { DKLabel, DKLine, showAlert, DKIcon, TOAST_TYPE, DKButton, DKInput, showToast, showLoader, removeLoader, INPUT_VIEW_DIRECTION } from "deskera-ui-library";
export default class GIROSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            giroAmount: this.props.data.giroAmount,
            selectedEmployee: this.props.data.selectedEmployee,
            totalNetPay: this.props.data.totalNetPay
        }
    }
    updateState(data) {
        this.setState({
            ...this.state,
            ...data
        })
    }
    getSummarySection = () => {
        return (
            <>
                <DKLabel text="GIRO SUMMARY" className="p-v-l fw-m text-gray" />
                <DKLine className="bg-gray3 " />
                <div className="p-v-l">
                    <div className="row justify-content-between ">
                        <DKLabel text="GIRO Amount" className="fw-m fs-l" />
                        <DKLabel text={FormatCurrencyService.format(this.state.giroAmount)} className="fw-m fs-l" />
                    </div>
                    <DKLabel text="Total Net Pay of Selected Employees" className="fw-m text-gray fs-s" />
                </div>
                <DKLine className="bg-gray3 " />

                <div className="p-v-l">
                    <div className="row justify-content-between ">
                        <DKLabel text="Employees" className="fw-m fs-l" />
                        <DKLabel text={this.state.selectedEmployee} className="fw-m fs-l" />
                    </div>
                    <DKLabel text="Number of Selected Employees" className="fw-m text-gray fs-s" />
                </div>
                <DKLine className="bg-gray3 " />

                <div className="p-v-l">
                    <div className="row justify-content-between ">
                        <DKLabel text="Total Net Pay" className="fw-m fs-l" />
                        <DKLabel text={FormatCurrencyService.format(this.state.totalNetPay)} className="fw-m fs-l" />
                    </div>
                    <DKLabel text="Total Amount for GIRO Eligible Employees" className="fw-m text-gray fs-s" />
                </div>
                <DKLine className="bg-gray3 mb-s" />

            </>
        )
    }
    render() {
        return (
            <>
                {this.getSummarySection()}
            </>
        )
    }
}